/* @flow */

import React from 'react';
import moment from 'moment';

import IntlMessageComponent from 'components/formatters/intlMessage';
import DatePickerComponent from 'components/formFields/dates/datePicker';

type BuyerPaymentReportFilterComponentProps = {
  fullWidth: boolean;
  margin: string;
  value: string;
  minDate: moment;
  changeHandler: (date: moment) => void;
}

export default function BuyerPaymentReportFilterComponent(props: BuyerPaymentReportFilterComponentProps) {

  const handleYearChange = (value: moment) => {
    return props.changeHandler(value);
  };

  return (
    <DatePickerComponent
      autoOk
      fullWidth
      maxDate={moment()}
      minDate={props.minDate ?? moment("2022-01-01")}
      value={props.value}
      onChange={handleYearChange}
      clearable={true}
      clearLabel={<IntlMessageComponent id="component.periodpicker.removefilter" />}
    />
  );
}
